import { ValuesType } from 'utility-types'
import ROUTES from 'constants/routes'
import { getEnv } from 'utils/environment'
import { GITHUB_TOKEN_SCOPE, TEAM_OWNERSHIP_TYPE } from './enums'

export const QUERY_KEYS = {
  ALIAS: 'Alias',
  APPLICATION_ITEMS: 'ApplicationItemsResult',
  APPLICATION_ITEMS_INFINITE: 'ApplicationItemsInfiniteResult',
  APPLICATION_PLATFORMS: 'ApplicationPlatformsResult',
  APPS_OWNERSHIP_TEAMS: 'AppsOwnershipTeamsResult',
  BILLING_INFO_RESULT: 'BillingInfoResult',
  CHECK_API_ACCESS: 'CheckApiAccess',
  COLLECTION_LIST_RESULT: 'CollectionListResult',
  COPILOT_ACTIVE_LICENSES: 'CopilotActiveLicenses',
  COPILOT_MONTHLY_USERS: 'CopilotMonthlyUsers',
  COMMON_QUESTIONS_DATA: 'CommonQuestionsDataResult',
  CONNECTION_SOURCES: 'ConnectionSourcesResult',
  CUSTOMER: 'CustomerResult',
  DASHBOARD_IDS_RESULT: 'DashboardIdsResult',
  DASHBOARD_LIST_RESULT: 'DashboardListResult',
  DASHBOARD_PARAM_VALUES_RESULT: 'DashboardParamValuesResult',
  DASHBOARD_RESULT: 'DashboardResult',
  DASHBOARD_SHARING_RESULT: 'DashboardSharingResult',
  DASHBOARD_VIEW_RESULT: 'DashboardViewResult',
  DATABASE_RESULT: 'DatabaseResult',
  DELTA_SHARE_RESULT: 'DeltaShareResult',
  DELTA_SHARES_RESULT: 'DeltaSharesResult',
  DELTA_SHARE_RECIPIENT_RESULT: 'DeltaShareRecipientResult',
  DELTA_SHARE_RECIPIENTS_RESULT: 'DeltaShareRecipientsResult',
  DEMO_WIDGET_DATA: 'DemoWidgetData',
  EMPLOYEE_DETAIL: 'EmployeeDetailResult',
  EMPLOYEE_QUICKVIEW: 'EmployeeQuickviewResult',
  EMPLOYEE_TEAM_NAMES_AND_UIDS: 'EmployeeTeamNamesAndUidsResult',
  EMPLOYEES_ASSIGN_CONNECTIONS: 'EmployeeAssignConnectionsResult',
  EMPLOYEES_FOR_TEAM_ASSIGN: 'EmployeesForTeamAssignResult',
  EMPLOYEES_BY_EMAIL: 'EmployeesByEmailResult',
  EMPLOYEES_FOR_SELECT: 'EmployeesForSelect',
  EMPLOYEES_COUNT: 'EmployeesForSelect',
  EMPLOYEES_INFINITE_LIST: 'EmployeesInfiniteList',
  EMPLOYEES_IDENTITY_EXISTS: 'EmployeesIdentityExistsResult',
  EMPLOYEES_MERGE_DATA: 'EmployeesMergeDataResult',
  EMPLOYEES_PAGE_DATA: 'EmployeesPageResult',
  EMPLOYEES_TEAMS: 'EmployeesTeamsResult',
  EMPLOYEES_TAGS: 'EmployeesTagsResult',
  EMPLOYEES_WITH_TEAMS_RESULT: 'EmployeesWithTeamsResult',
  EMPLOYEES_WITH_VCS: 'EmployeesWithVcs',
  EPICS: 'EpicsResult',
  EVENTS_GENERATOR: 'EventsGeneratorResult',
  FAROS_METRIC_DEFINITION_TAGS: 'FarosMetricDefinitionTagsResult',
  FAROS_METRIC_DEFINITIONS: 'FarosMetricDefinitionsResult',
  FAROS_SCORECARD_METRICS: 'FarosScorecardMetrics',
  FEATURE_TOGGLES: 'FeatureTogglesResult',
  FIELD_DISTINCT_VALUES: 'FieldDistinctValuesResult',
  FLOWS_DEFINITIONS: 'FlowsDefinitionsResult',
  FLOWS_STEPS: 'FlowsStepsResult',
  FLOWS_TAGS: 'FlowsTagsResult',
  FLOWS_TEMPLATE_STEPS: 'FlowsTemplateStepsResult',
  FRONTEGG_USERS: 'FronteggUsers',
  FRONTEGG_USERS_ROLES: 'FronteggUsersRoles',
  GITHUB_REPO_LATEST_RELEASE: 'GithubRepoLatestRelease',
  GITHUB_SEARCH_REPOS: 'GithubSearchRepos',
  GITHUB_USER_ORGANIZATIONS: 'GithubUserOrganizations',
  GRAPH_STATISTICS: 'GraphStatistics',
  GRAPHS_GRAPHQL_QUERY: 'GraphsGraphQLQuery',
  GRAPHS_GRAPHQL_SCHEMA: 'GraphsGraphQLSchema',
  GRAPHS_RESULT: 'GraphsResult',
  IGNORED_ITEMS_COUNT: 'IgnoredItemsCountResult',
  INCLUSION_ITEM_COUNT: 'InclusionItemCount',
  INITIATIVE: 'InitiativeResult',
  INITIATIVES: 'InitiativesResult',
  INITIATIVES_OWNERS: 'InitiativesOwnersResult',
  INVOICES: 'InvoicesResult',
  INVOICES_UPCOMING: 'InvoicesUpcomingResult',
  METABASE_CARDS: 'MetabaseCards',
  MODULES_DEFAULT_RESULT: 'ModulesDefaultResult',
  NAMED_QUERIES_RESULT: 'NamedQueriesResult',
  NAMED_QUERY_RESULT: 'NamedQueryResult',
  NEXTAUTH_PROVIDERS: 'NextAuthProvidersResult',
  OWNERSHIP_TEAMS: 'OwnershipTeamsResult',
  PAYMENT_METHODS_RESULT: 'PaymentMethodsResult',
  PIPELINE_ITEMS: 'PipelineItemsResult',
  PIPELINE_ITEMS_INFINITE: 'PipelineItemsInfiniteResult',
  PIPELINE_SOURCES: 'PipepelineSourcesResult',
  PIPELINES_OWNERSHIP_TEAMS: 'PipelinesOwnershipTeamsResult',
  PREFERENCES: 'PreferencesResult',
  RELEASES: 'ReleasesResult',
  RELEASES_FIELDS: 'ReleasesFieldsResult',
  REMOVE_TEAM_MEMBER_DATA_RESULT: 'RemoveTeamMemberDataResult',
  REPORT_PIPELINE_PERMISSIONS: 'PipelinePermissionsResult',
  REPORT_SCHEDULE_RUNS_RESULT: 'ReportScheduleRunsResult',
  REPORT_SCHEDULES_RESULT: 'ReportSchedulesResult',
  REPORT_SCHEDULES_RESULT_WITH_LAST_RUN: 'ReportSchedulesResultWithLastRun',
  REPOSITORIES_OWNERSHIP_TEAMS: 'RepositoriesOwnershipTeamsResult',
  REPOSITORY_ITEMS: 'RepositoryItemsResult',
  REPOSITORY_ITEMS_INFINITE: 'RepositoryItemsInfiniteResult',
  REPOSITORY_ORGANIZATIONS: 'RepositoryOrganizationsResult',
  REPOSITORY_SOURCES: 'RepositorySourcesResult',
  RND_CAPITALIZATION_DEFINITION: 'RnDCapitalizationDefinitionResult',
  SCORECARD: 'ScorecardResult',
  SCORECARD_TEAM_BREAKDOWN: 'ScorecardTeamBreakdownResult',
  SEATS_RESULT: 'SeatsResult',
  SECRET_RESULT: 'SecretResult',
  SECRETS_RESULT: 'SecretsResult',
  SERVER_DATE_RESULT: 'ServerDateResult',
  SETUP_INTENT_RESULT: 'SetupIntentResult',
  STATIC_LICENSE_RESULT: 'StaticLicenseResult',
  SUBSCRIPTIONS_RESULT: 'SubscriptionsResult',
  TASK_ADDITIONAL_FIELDS: 'TaskAdditionalFields',
  TASK_BOARD_ITEMS: 'TaskBoardItemsResult',
  TASK_BOARD_ITEMS_INFINITE: 'TaskBoardItemsInfiniteResult',
  TASK_BOARD_PROJECTS: 'TaskBoardProjectsResult',
  TASK_BOARD_SOURCES: 'TaskBoardSourcesResult',
  TASK_BOARDS_OWNERSHIP_TEAMS: 'TaskBoardsOwnershipTeamsResult',
  TASKS: 'TasksResult',
  TEAM_APP_OWNERSHIPS_RESULT: 'TeamAppOwnershipsResult',
  TEAM_CHAIN_DATA_RESULT: 'TeamChainDataResult',
  TEAM_DORA_METRICS_RESULT: 'TeamDoraMetricsResult',
  TEAM_EDIT_DATA_RESULT: 'TeamEditDataResult',
  TEAM_MEMBERS_RESULT: 'TeamMembersResult',
  TEAM_OWNERSHIP_RESULT: 'TeamOwnershipResult',
  TEAM_PIPELINE_OWNERSHIP_RESULT: 'TeamPipelineOwnershipsResult',
  TEAM_REPOSITORY_OWNERSHIP_RESULT: 'TeamRepositoryOwnershipsResult',
  TEAM_RESULT: 'TeamResult',
  TEAM_TASK_BOARD_OWNERSHIP_RESULT: 'TeamTaskBoardOwnershipsResult',
  TEAM_WIDGETS: 'TeamWidgets',
  TEAM_QUICK_VIEW_RESULT: 'TeamQuickViewResult',
  TEAMS_LIST: 'TeamsList',
  TEAMS_INFINITE_LIST: 'TeamsInfiniteList',
  TEAMS_RESULT: 'TeamsResult',
  TEAMS_WITH_APPLICATIONS: 'TeamsWithApplicationsResult',
  TEAMS_WITH_PIPELINES: 'TeamsWithPipelinesResult',
  TEAMS_WITH_REPOSITORIES: 'TeamsWithRepositoriesResult',
  TEAMS_WITH_TASK_BOARDS: 'TeamsWithTaskBoardsResult',
  TENANT_ACCOUNT_LATEST_SYNC: 'TenantAccountLatestSync',
  TENANT_ACCOUNT_LOGS: 'TenantAccountLogs',
  TENANT_ACCOUNT_LOGS_RESULT: 'TenantAccountLogsResult',
  TENANT_ACCOUNT_SYNC_LOGS_RESULT: 'TenantAccountSyncLogsResult',
  TENANT_ACCOUNTS_RESULT: 'TenantAccountsResult',
  TENANT_ACCOUNT_SYNC_STATUSES: 'TenantAccountSyncStatuses',
  TENANT_API_KEYS_RESULT: 'TenantAPIKeysResult',
  TENANT_AVAILABILITY_RESULT: 'TenantAvailabilityResult',
  TENANT_COLLECTION_RESULT: 'TenantCollectionResult',
  UNASSIGNED_TEAM_OWNERSHIPS_RESULT: 'UnassignedTeamOwnershipsResult',
  UNASSIGNED_TEAM_RESULT: 'UnassignedTeamResult',
  UNASSIGNED_USER_CONNECTIONS: 'UnassignedUserConnections',
  USER_IDENTITY_CONNECTIONS: 'UserIdentityConnections',
  USER_PROFILE: 'UserProfile',
  USER_ROLE_SCOPES: 'UserRoleScopesResult',
  USER_SCOPES: 'UserScopesResult',
  USER_UNASSIGNED_CONNECTIONS_EXISTS: 'UserAccountsExists',
  UNASSIGNED_VCS_USERS: 'UnassignedVcsUsers',
  UNASSIGNED_AMS_USERS: 'UnassignedAmsUsers',
  UNASSIGNED_IMS_USERS: 'UnassignedImsUsers',
  UNASSIGNED_TMS_USERS: 'UnassignedTmsUsers',
  UNASSIGNED_CAL_USERS: 'UnassignedCalUsers',
  UNASSIGNED_USER_SOURCES: 'UnassignedUserSources',
  UNASSIGNED_EMPLOYEE_SOURCES: 'UnassignedEmployeeSources',
  TAGS: 'Tags',
  TEAM_TAGS: 'TeamTags',
  VALIDATE_ORG_DATA: 'ValidateOrgData',
  UPLOAD_ORG_DATA: 'UploadOrgData',
  NOTIFICATIONS: 'Notifications',
  WORKFLOWS_AP_TOKEN: 'WorfklowsAPToken',
  CUSTOM_PAGES: 'CustomPages',
} as const

// Use less items per page when running test
// Won't need to create as many mocked items to fill one page and test pagination
export const PAGE_SIZE_OPTIONS =
  process.env.NEXT_PUBLIC_APP_ENV === 'test' ? [3, 6, 9, 12] : [5, 10, 25, 50]
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0]

export const DEFAULT_GRAPH_NAME = 'default'
// graph version is deprecated but is still used in Faros/Metabase API requests (header)
// and Metabase SSO (user attribute) https://faros-ai.atlassian.net/browse/FAI-9319?focusedCommentId=23834
// will be removed in the future
export const DEFAULT_GRAPH_VERSION = 'v2'
export const DEFAULT_GRAPH = {
  name: DEFAULT_GRAPH_NAME,
} as const

export const Z_INDEX = {
  UNDERLAY: -1,
  DEFAULT: 0,
  CODE_MIRROR_COPY_BUTTON: 2,
  OVERLAY: 2,
  TABLE_HEADER_CELL: 1,
  EXCESS_LABEL: 1,
  TABLE_ACTIONS: 2,
  DROPDOWN: 3,
  CLOSE_BUTTON: 4,
  ACCOUNT_DROPDOWN: 11,
  TOP_NAVIGATION: 10,
  LEFT_HAND_PANEL: 10,
  PORTAL: 20,
}
export const TOP_BAR_HEIGHT = '64px'

export const USER_INPUT_DEBOUNCE = 400

export const TEAM_OWNERSHIP_TYPE_PLURAL: Record<TEAM_OWNERSHIP_TYPE, string> = {
  [TEAM_OWNERSHIP_TYPE.APPLICATION]: 'applications',
  [TEAM_OWNERSHIP_TYPE.REPOSITORY]: 'repositories',
  [TEAM_OWNERSHIP_TYPE.TASK_BOARD]: 'boards',
  [TEAM_OWNERSHIP_TYPE.PIPELINE]: 'pipelines',
}

export const TEAM_OWNERSHIP_TYPE_SINGULAR: Record<TEAM_OWNERSHIP_TYPE, string> =
  {
    [TEAM_OWNERSHIP_TYPE.APPLICATION]: 'application',
    [TEAM_OWNERSHIP_TYPE.REPOSITORY]: 'repository',
    [TEAM_OWNERSHIP_TYPE.TASK_BOARD]: 'board',
    [TEAM_OWNERSHIP_TYPE.PIPELINE]: 'pipeline',
  }

export const TEAM_OWNERSHIP_TYPE_SINGULAR_WITH_ARTICLE: Record<
  TEAM_OWNERSHIP_TYPE,
  string
> = {
  [TEAM_OWNERSHIP_TYPE.APPLICATION]: 'an application',
  [TEAM_OWNERSHIP_TYPE.REPOSITORY]: 'a repository',
  [TEAM_OWNERSHIP_TYPE.TASK_BOARD]: 'a board',
  [TEAM_OWNERSHIP_TYPE.PIPELINE]: 'a pipeline',
}

export const REQUIRED_GITHUB_TOKEN_SCOPES = [
  GITHUB_TOKEN_SCOPE.REPO,
  GITHUB_TOKEN_SCOPE.READ_USER,
  GITHUB_TOKEN_SCOPE.READ_ORG,
]

export const METABASE_SESSION_KEY = 'metabase-user-session'
export const METABASE_CONFIG = {
  DATA_GROUP: 'Faros Data',
  REPORTS_GROUP: 'Faros Reports',
  REPORTS_COLLECTION: 'Faros reports',
  TENANT_GROUP: (tenantId: string) => `Tenant ${tenantId}`,
  TENANT_SHARED_COLLECTION: (tenantId: string) => `${tenantId} shared reports`,
  TENANT_ADMINISTRATORS_GROUP: (tenantId: string) =>
    `Tenant ${tenantId} Administrators`,
  TENANT_VIEWERS_GROUP: (tenantId: string) => `Tenant ${tenantId} Viewers`,
  TENANT_CURATED_COLLECTION: (tenantId: string) =>
    `${tenantId} curated reports`,
  CUSTOM_REPORTS_COLLECTION: 'Custom reports',
  CURATED_REPORTS_COLLECTION: 'Curated reports',
  SHARED_REPORTS_COLLECTION: 'Shared reports',
}

/**
 * `REDIRECT_URL_QUERY_PARAM_KEY` is name of the query parameter
 * used by Frontegg to redirect user to the previous location
 * after he successfully logs in to the application.
 * https://github.com/frontegg/frontegg-react/blob/ebd021d4e835ab012248dbf970dac351ca0e3299/packages/auth/src/SignUp/SignUpSuccess.tsx#L22
 */
export const REDIRECT_URL_QUERY_PARAM_KEY = 'redirectUrl'

export const LOCAL_STORAGE_KEYS = {
  CURRENT_GRAPH_NAME: 'alastor-current-graph-name',
  TEAM_PAGE_LAYOUT: 'team-page-layout-v3-demo',
  UNLEASH_SESSION_ID: 'unleash:repository:sessionId',
}

export const FAROS_AI_BUSINESS_NAME = 'Faros AI, Inc'

const FAROS_LANDING_PAGE_URL = getEnv('NEXT_PUBLIC_FAROS_LANDING_PAGE_URL')
const PAGE_NOT_FOUND_ROUTE = '/404'

export const FAROS_WEBSITE = {
  PRICING: FAROS_LANDING_PAGE_URL
    ? `${FAROS_LANDING_PAGE_URL}/pricing`
    : PAGE_NOT_FOUND_ROUTE,
  PRODUCTS: FAROS_LANDING_PAGE_URL
    ? `${FAROS_LANDING_PAGE_URL}/products`
    : PAGE_NOT_FOUND_ROUTE,
  SIGN_UP: FAROS_LANDING_PAGE_URL
    ? `${FAROS_LANDING_PAGE_URL}/signup`
    : PAGE_NOT_FOUND_ROUTE,
}

export const TIER = {
  ENTERPRISE: 'enterprise',
  PROFESSIONAL: 'professional',
} as const

export type Tier = ValuesType<typeof TIER>

export const CATALOG_SELECT_FIELD_OTHER_VALUE = 'SELECT_OTHER_VALUE'

export const FAROS_SUPPORT_EMAIL = 'support@faros.ai'
export const FAROS_SALES_EMAIL = 'sales@faros.ai'
export const FAROS_BILLING_EMAIL = 'billing@faros.ai'

export const TODAY = new Date()

/**
 * Team with `{uid: "unassigned"}` is used instead of removing entity from team.
 * It is also hidden from UI and all entities with this team act like, they have no team.
 */
export const UNASSIGNED_TEAM = 'unassigned'

/**
 * Default message for <Prompt /> component
 */
export const DEFAULT_PROMPT_MESSAGE =
  'Are you sure you want to leave? All changes will be lost.'

export const FAROS_GRAPHQL_VERSION_HEADER = 'x-faros-graph-version'
export const METABASE_SESSION_HEADER = 'X-Metabase-Session'
export const SENTRY_TRACE_HEADER = 'sentry-trace'
export const VERCEL_REQ_ID_HEADER = 'x-vercel-id'

/**
 * Check if Sentry environment is set
 */
export const IS_SENTRY_SET: boolean = !!getEnv('NEXT_PUBLIC_SENTRY_ENVIRONMENT')

export const FAROS_TENANT = 'faros'

// Cookies used in "dynamic dashboard" feature
export const TOKEN_COOKIE_NAME = 'alastor-token'
export const GRAPH_COOKIE_NAME = 'alastor-current-graph'

export const CUSTOM_EMPLOYMENT_TYPE = 'Custom'

export const DEFAULT_COMPANY_HOMEPAGE = ROUTES.DASHBOARDS.COLLECTIONS

export const SEATS_EXPLANATION_TEXT =
  'A seat constitutes an active contributor to your organization. Only active employees count towards the seat count.'

export const DEFAULT_COMPANY_NAME = 'Company'

/**
 * Properties from provider config next-auth v3
 */
export const OLD_PROVIDER_CONFIG_PROPERTIES = {
  DOMAIN: 'domain',
  AUTHORIZATION: {
    URL: 'authorizationUrl',
    PARAMS: 'authorizationParams',
    SCOPE: 'scope',
  },
  TOKEN: {
    URL: 'accessTokenUrl',
    PARAMS: 'params',
  },
  PROFILE_URL: 'profileUrl',
}

export const METABASE_WIDGET_SOURCES = {
  DEVELOPER_EXPERIENCE_SUMMARY: 'Developer Experience Summary',
  DORA: 'Organization DORA Summary',
}

export const SENTRY_DSN =
  'https://eeb9fa0d27604a1ea770ba38f3833805@o1011160.ingest.sentry.io/5976020'
